import React from 'react';
import { useParams } from 'react-router-dom';

const DaybookDetail = () => {
  const { id } = useParams();
  return (
    <div data-testid="daybook-detail-page">
      <div className="bg-card rounded-xl shadow-sm border border-border p-8">
        <h2 className="text-xl font-semibold mb-4">Dagbok Detaljer</h2>
        <p className="text-muted-foreground">Dagbok ID: {id}</p>
      </div>
    </div>
  );
};

export default DaybookDetail;
